module.exports = __webpack_public_path__ + "img/banner.4c07a9fc.png";